export default __webpack_public_path__ + "src/images/galleries/1/preface_bg-984b34.png";